import { IButtonStyles, memoizeFunction, mergeStyles, mergeStyleSets } from '@fluentui/react';
import { IAppTheme } from 'common';

export const getIconClassName = memoizeFunction(() =>
  mergeStyles({
    marginTop: 2,
  })
);

export const getStyles = memoizeFunction(
  (customStyles: IButtonStyles | undefined, { appFonts, semanticColors }: IAppTheme, isIconButton: boolean) =>
    mergeStyleSets(
      {
        label: {
          ...appFonts?.Body1Strong,
        },
        menuIcon: {
          display: 'none',
        },
        root: isIconButton && {
          // TODO: move to theme level for all icon buttons?
          borderRadius: '100%',
          '&:focus::after': {
            borderRadius: '100%',
            border: `2px solid ${semanticColors.buttonText} !important`,
            inset: '0px !important',
            outline: 'none !important',
          },
        },
      } as IButtonStyles,
      customStyles
    )
);
